import { render, staticRenderFns } from "./DashboardLayoutCrmSalon.vue?vue&type=template&id=081ed736&"
import script from "./DashboardLayoutCrmSalon.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutCrmSalon.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutCrmSalon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports